module.exports = __webpack_public_path__ + "static/media/tick.f24f5078.svg";